import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITEM_ADITIVO_APOSTILA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.RESET_INFORMACOES_ITEM_ADITIVO_APOSTILA](state) {
		state.idAditivoApostila = null
		state.tipoOperacao = 'ACRESCIMO'
		state.quantidade = null
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_INFORMACOES_ITEM_ADITIVO_APOSTILA](
		state,
		informacoesModalAcrescimoSupressao,
	) {
		state.idAditivoApostila = informacoesModalAcrescimoSupressao.idAditivoApostila
		state.tipoOperacao = informacoesModalAcrescimoSupressao.tipoOperacao
		state.quantidade = informacoesModalAcrescimoSupressao.quantidade
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_TIPO_OPERACAO](state, tipoOperacao) {
		state.tipoOperacao = tipoOperacao
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_QUANTIDADE_SUPRESSAO_ACRESCIMO](state, quantidade) {
		state.quantidade = quantidade
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.ITEM_ADITIVO_APOSTILA_SELECIONADO](state, itens) {
		state.itensAditivoApostilaSelecionados = itens
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.SET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensAditivoApostila = true
	},
	[mutationTypes.ITEM_ADITIVO_APOSTILA.UNSET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensAditivoApostila = false
	},
}
